import { Component, Input } from '@angular/core';

@Component({
  selector: 'map-feature-item',
  templateUrl: `./map-feature-item.component.html`,
  styleUrls: ['./map-feature-item.component.scss'],
})
export class MapFeatureItemComponent {
  @Input() feature;

  public isArray = Array.isArray;
}
